const emptyList = [];

export const selectCatalogByName = (catalogName) => (state) =>
  state.catalogos.data[catalogName] || emptyList;

export const selectCatalogs = (state) => state.catalogos;

export const selectTipoHallazgoByIdMonitoreo = (tipoSeleccionado) => (state) =>
  state.catalogos.data.tipoMonitoreos?.find(
    (tipoMonitoreo) => tipoMonitoreo.idTipoMonitoreo === tipoSeleccionado
  )?.tipoHallazgos || emptyList;

export const selectfirmanteByUsuario = (usuarioActual) => (state) =>
  state.catalogos.data.usuariosFiscalizacion?.find(
    (usuarioFisca) => usuarioFisca.usuario === usuarioActual
  )?.idUsuario || emptyList;

export const selectCatalogValoracionesConverter = () => (state) => {
  const valoracionesUTFArray = [];

  if (
    state.catalogos !== undefined &&
    state.catalogos.data !== undefined &&
    state.catalogos.data.valoracionesUTF !== undefined
  ) {
    state.catalogos.data.valoracionesUTF?.forEach((item) => {
      valoracionesUTFArray?.push({
        value: item.idValoracion,
        label: item.descripcion
      });
    });
  }

  return valoracionesUTFArray;
};
